module.exports = __webpack_public_path__ + "static/img/yunying.cb1ee19b.png";